module.exports = __webpack_public_path__ + "media/images/sp/specials/common/special_c_05-044938cd7c53cc43bf21ab6e27e4dc8e.png";